export default function offerFavouritesOptionsResolver({ offer, itemSettings, offerSettings }) {
    return {
        bind: {
            offer,
            settings: itemSettings,
            favouritesSettings: offerSettings.favourites,
        },
    };
}
